const ALL_TYPES = [
    "aqfer", "api_key", "auth", "aws", "azure", "basic", "bing_ads", "boostr",
    "comscore", "databricks", "facebook", "freewheel", "ftp", "gcp", "google_ads",
    "hash_salt", "hash_key", "nielsen", "papi", "rsa_key_pair", "ssh", "trade_desk",
    "youtube_analytics_v2",
];

const USERNAME_PASSWORD_TYPES = ["basic", "boostr", "comscore", "freewheel", "ftp", "nielsen", "trade_desk"];

const Fields = [
    {
        name: "name",
        label: "Name",
        toolTip: "Credential name",
        type: "text",
        editable: false,
        visible: false,
        validation: [
            { type: "required", errMsg: "Credential name is required" }
        ],
        filterByType: ALL_TYPES
    },
    {
        name: "type",
        label: "Type",
        toolTip: "Credential type",
        type: "select",
        options: [
            { label: "Aqfer", value: "aqfer" },
            { label: "API Key", value: "api_key" },
            { label: "Auth (deprecated)", value: "auth" },
            { label: "AWS", value: "aws" },
            { label: "Azure", value: "azure" },
            { label: "Basic", value: "basic" },
            { label: "Bing Ads", value: "bing_ads" },
            { label: "Boostr", value: "boostr" },
            { label: "Comscore", value: "comscore" },
            { label: "Databricks", value: "databricks" },
            { label: "Facebook", value: "facebook" },
            { label: "Freewheel", value: "freewheel" },
            { label: "FTP", value: "ftp" },
            { label: "GCP", value: "gcp" },
            { label: "Google Ads", value: "google_ads" },
            { label: "Hash Salt", value: "hash_salt" },
            { label: "Hash Key", value: "hash_key" },
            { label: "Nielsen", value: "nielsen" },
            { label: "PAPI", value: "papi" },
            { label: "RSA Key Pair", value: "rsa_key_pair" },
            { label: "SSH", value: "ssh" },
            { label: "Trade Desk", value: "trade_desk" },
            { label: "YouTube Analytics V2", value: "youtube_analytics_v2" },
        ],
        defaultValue: "aqfer",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Credential type is required" }
        ],
        filterByType: ALL_TYPES
    },
    // Aqfer / Auth (deprecated) / Bing Ads / Google Ads Credential Fields
    {
        name: "refresh_token",
        label: "Refresh Token",
        toolTip: "Refresh token used for obtaining new access tokens",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Refresh token is required" }
        ],
        filterByType: ["aqfer", "auth", "bing_ads", "google_ads"]
    },
    // API Key Credential Fields
    {
        name: "api_key",
        label: "API Key",
        toolTip: "API Key for authenticating and accessing the API",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "API Key is required" }
        ],
        filterByType: ["api_key", "nielsen"]
    },
    // AWS Credential Fields
    {
        name: "access_key",
        label: "Access Key",
        toolTip: "Access key used for authentication",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["aws", "azure"]
    },
    {
        name: "secret_key",
        label: "Secret Key",
        toolTip: "AWS secret key used for authentication",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["aws"]
    },
    {
        name: "session_token",
        label: "Session Token",
        toolTip: "AWS session token for temporary credentials",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["aws"]
    },
    {
        name: "role_arn",
        label: "Role ARN",
        toolTip: "AWS role ARN for assuming IAM role",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["aws"]
    },
    {
        name: "external_id",
        label: "External ID",
        toolTip: "External ID for role assumption security",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["aws"]
    },
    {
        name: "region",
        label: "Region",
        toolTip: "AWS region",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["aws"]
    },
    // Azure Credential Fields
    {
        name: "account_name",
        label: "Account Name",
        toolTip: "Name of the Azure Storage Account to access or authenticate against",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Account name is required" }
        ],
        filterByType: ["azure"]
    },
    {
        name: "shared_signature",
        label: "Shared Signature",
        toolTip: "Shared Signature for accessing Azure services",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Shared signature is required" }
        ],
        filterByType: ["azure"]
    },
    // Basic-style Credential Fields (basic, boostr, comscore, freewheel, ftp, nielsen, trade_desk)
    {
        name: "username",
        label: "Username",
        toolTip: "Username/Email associated with the user account",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Username is required" }
        ],
        filterByType: [...USERNAME_PASSWORD_TYPES, "ssh"]
    },
    {
        name: "password",
        label: "Password",
        toolTip: "Password associated with the user account",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Password is required" }
        ],
        filterByType: [...USERNAME_PASSWORD_TYPES, "ssh"]
    },
    // Bing Ads Credential Fields
    {
        name: "developer_token",
        label: "Developer Token",
        toolTip: "Unique token assigned to the developer or application accessing the API",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Developer token is required" }
        ],
        filterByType: ["bing_ads", "google_ads"]
    },
    {
        name: "client_state",
        label: "Client State",
        toolTip: "Unique state value used during the authentication process for security purposes",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Client state is required" }
        ],
        filterByType: ["bing_ads"]
    },
    // Databricks Credential Fields
    {
        name: "workspace_url",
        label: "Workspace URL",
        toolTip: "Databricks workspace URL",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Workspace URL is required" }
        ],
        filterByType: ["databricks"]
    },
    {
        name: "secret",
        label: "Secret",
        toolTip: "Service principal secret",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Secret is required" }
        ],
        filterByType: ["databricks"]
    },
    {
        name: "account_id",
        label: "Account ID",
        toolTip: "Required only for Databricks account operations",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["databricks"]
    },
    // Facebook Credential Fields
    {
        name: "app_id",
        label: "App ID",
        toolTip: "Unique identifier for the Facebook application",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["facebook"]
    },
    {
        name: "ad_account_id",
        label: "Ad Account ID",
        toolTip: "Ad Account ID associated with the Facebook advertising account",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["facebook"]
    },
    {
        name: "app_scoped_user_id",
        label: "App-Scoped User ID",
        toolTip: "App-Scoped User ID associated with the Facebook user",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["facebook"]
    },
    {
        name: "access_token",
        label: "Access Token",
        toolTip: "Access Token for authenticating and accessing resources",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Access token is required" }
        ],
        filterByType: ["facebook", "papi"]
    },
    // GCP / Google Ads / YouTube Analytics V2 Credential Fields
    {
        name: "project_id",
        label: "Project ID",
        toolTip: "GCP Project ID",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Project ID is required" }
        ],
        filterByType: ["gcp", "google_ads", "youtube_analytics_v2"]
    },
    {
        name: "private_key_id",
        label: "Private Key ID",
        toolTip: "ID associated with the private key",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Private key ID is required" }
        ],
        filterByType: ["gcp", "google_ads", "youtube_analytics_v2"]
    },
    {
        name: "private_key",
        label: "Private Key",
        toolTip: "Private key used for authentication",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Private key is required" }
        ],
        filterByType: ["gcp", "google_ads", "youtube_analytics_v2", "rsa_key_pair", "ssh"]
    },
    {
        name: "client_email",
        label: "Client Email",
        toolTip: "Service account email",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Client email is required" }
        ],
        filterByType: ["gcp", "google_ads", "youtube_analytics_v2"]
    },
    {
        name: "client_id",
        label: "Client ID",
        toolTip: "Client ID",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Client ID is required" }
        ],
        filterByType: ["gcp", "google_ads", "youtube_analytics_v2", "bing_ads", "databricks"]
    },
    {
        name: "auth_uri",
        label: "Auth URI",
        toolTip: "Authorization URI",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Auth URI is required" }
        ],
        filterByType: ["gcp", "google_ads", "youtube_analytics_v2"]
    },
    {
        name: "token_uri",
        label: "Token URI",
        toolTip: "Token URI",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Token URI is required" }
        ],
        filterByType: ["gcp", "google_ads", "youtube_analytics_v2"]
    },
    {
        name: "auth_provider_x509_cert_url",
        label: "Auth Provider X509 Cert URL",
        toolTip: "Auth provider certificate URL",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Auth provider certificate URL is required" }
        ],
        filterByType: ["gcp", "google_ads", "youtube_analytics_v2"]
    },
    {
        name: "client_x509_cert_url",
        label: "Client X509 Cert URL",
        toolTip: "Client certificate URL",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Client certificate URL is required" }
        ],
        filterByType: ["gcp", "google_ads", "youtube_analytics_v2"]
    },
    {
        name: "client_secret",
        label: "Client Secret",
        toolTip: "Client Secret used for authentication",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["google_ads", "papi"]
    },
    {
        name: "login_customer_id",
        label: "Login Customer ID",
        toolTip: "Login Customer ID for the Google Ads account",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Login customer ID is required" }
        ],
        filterByType: ["google_ads"]
    },
    {
        name: "service_account_user",
        label: "Service Account User",
        toolTip: "Email address of the user to impersonate",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["google_ads"]
    },
    {
        name: "linked_customer_id",
        label: "Linked Customer ID",
        toolTip: "Customer IDs associated with the Google Ads account (comma separated)",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Linked customer ID is required" }
        ],
        filterByType: ["google_ads"]
    },
    {
        name: "content_owner_id",
        label: "Content Owner ID",
        toolTip: "Content Owner ID associated with YouTube Analytics",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Content owner ID is required" }
        ],
        filterByType: ["youtube_analytics_v2"]
    },
    // Hash Salt / Hash Key Credential Fields
    {
        name: "salt_id",
        label: "Salt ID",
        toolTip: "ID associated with the pepper/salt used for hashing",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Salt ID is required" }
        ],
        filterByType: ["hash_salt"]
    },
    {
        name: "salt",
        label: "Salt",
        toolTip: "Salt value",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Salt is required" }
        ],
        filterByType: ["hash_salt"]
    },
    {
        name: "pepper",
        label: "Pepper",
        toolTip: "Pepper value used for hashing",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Pepper is required" }
        ],
        filterByType: ["hash_key"]
    },
    // PAPI Credential Fields
    {
        name: "host",
        label: "Host",
        toolTip: "PAPI host",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Host is required" }
        ],
        filterByType: ["papi"]
    },
    {
        name: "client_token",
        label: "Client Token",
        toolTip: "Client token for PAPI",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Client token is required" }
        ],
        filterByType: ["papi"]
    },
    // SSH Credential Fields
    {
        name: "timeout",
        label: "Timeout",
        toolTip: "Connection timeout for SSH",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["ssh"]
    },
];

export default Fields;
